import { axios } from '@Root/API'

export const duplicate = data => {
	return axios.post('duplicate/student-course-session', data)
}
